import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    globalUser: null,
    token: null,
    loginRevision: 0,
    idPaciente: 0,
    institution: null,
    roles: [],
    toolsByUser: {},
    activeApplication: null,
    theme: {
      mode: 'dark',
      primaryColor: '#F2B84B',
      borderRadius: 8,
    }
  },
  reducers: {
    setGlobalUser: (state, action) => {
      state.globalUser = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = {
        ...(state.theme || {}),
        ...(action.payload || {}),
      };
    },
    setLocation: (state, action) => {
      state.globalUser = action.payload;
    },
    setInstitution: (state, action) => {
      state.institution = action.payload;
      state.activeApplication = null;
    },
    setUserTools: (state, action) => {
      const { userId, tools } = action.payload || {};
      if (!userId) return;
      state.toolsByUser = {
        ...(state.toolsByUser || {}),
        [userId]: Array.isArray(tools) ? tools : []
      };
    },
    setActiveApplication: (state, action) => {
      if (!['tgone', 'cemedi'].includes(action.payload)) return;
      state.activeApplication = action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload || [];
    },
    removeGlobalUser: (state, action) => {
      state.globalUser = null;
      state.roles = [];
    },
    setToken: (state, action) => {
      state.token = action.payload;
      if (action.payload) {
        state.loginRevision = (state.loginRevision || 0) + 1;
      }
    },
    removeToken: (state) => {
      state.token = null;
    },
    removeInstitution: (state) => {
      state.institution = null;
      state.activeApplication = null;
    },
    setIdPaciente: (state, action) => {
      state.idPaciente = action.payload;
    },
    removeIdPaciente: (state) => {
      state.idPaciente = 0;
    }
  },
})

export const { setGlobalUser, setLocation, setInstitution, setUserTools, setActiveApplication, removeGlobalUser, setToken, removeToken, setIdPaciente, removeIdPaciente, removeInstitution, setTheme } = sessionSlice.actions;

export default sessionSlice.reducer;
